module.exports = __webpack_public_path__ + "img/38-s.c6858ec0.png";